import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import {
  APP_FORM_SECTIONS,
  APP_FORM_FIELDS,
} from "../../constants/Dashboard/appConstants";
import "../../assets/css/Apps/AppForm.css";

const AppForm = ({ formik, isSubmitting }) => {
  const renderField = (field) => {
    const { name, label, required, type = "text" } = field;
    const hasError = formik.touched[name] && formik.errors[name];

    return (
      <Form.Group className="mb-3" key={name}>
        <Form.Label className={"formLabel"}>
          {label}
          {required && <span className={"required"}>*</span>}
        </Form.Label>
        {type === "textarea" ? (
          <Form.Control
            as="textarea"
            rows={3}
            name={name}
            value={formik.values[name] ?? ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={hasError}
            disabled={isSubmitting}
            className={"formControl"}
          />
        ) : (
          <Form.Control
            type={type}
            name={name}
            value={formik.values[name] ?? ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={hasError}
            disabled={isSubmitting}
            className={"formControl"}
            placeholder={`Enter ${label.toLowerCase()}`}
          />
        )}
        {hasError && (
          <Form.Control.Feedback type="invalid" className={"errorMessage"}>
            {formik.errors[name]}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    );
  };

  return (
    <Form onSubmit={formik.handleSubmit} className={"form"}>
      <Row>
        <Col md={6}>
          <div className={"section"}>
            <h6 className={"sectionTitle"}>{APP_FORM_SECTIONS.GENERAL}</h6>
            {APP_FORM_FIELDS.GENERAL.map(renderField)}
          </div>
        </Col>
        <Col md={6}>
          <div className={"section"}>
            <h6 className={"sectionTitle"}>{APP_FORM_SECTIONS.ANDROID}</h6>
            {APP_FORM_FIELDS.ANDROID.map(renderField)}
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <div className={"section"}>
            <h6 className={"sectionTitle"}>{APP_FORM_SECTIONS.IOS}</h6>
            <Row>
              <Col md={6}>
                {APP_FORM_FIELDS.IOS.slice(0, 2).map(renderField)}
              </Col>
              <Col md={6}>{APP_FORM_FIELDS.IOS.slice(2).map(renderField)}</Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default AppForm;
